import {
  MiddlewareAPI,
  isRejectedWithValue,
  Middleware,
} from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { logout } from "../../authentication/authSlice";

type ErrorData = {
  errorCode: string;
  value: string;
  field: string;
  level: string;
};

export const rtkQueryErrorLogger: Middleware =
  (api: MiddlewareAPI) => (next) => (action: any) => {
    // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these matchers!
    if (isRejectedWithValue(action)) {
      if (action?.payload?.status === 401 || action?.payload?.status === 403) {
        api.dispatch(logout(null));
      } else {
        let message =
          "We could not take the requested action. Please reach out to your TOTE Services contact for additional information.";
        if (typeof action?.payload?.data?.map === "function") {
          message = action.payload.data
            .map((data: ErrorData) => data.value)
            .join(". ");
        } else if (!!action?.payload?.data?.message) {
          message = action.payload.data.message;
        }

        toast.error(message, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    }

    return next(action);
  };
